/* eslint-disable @typescript-eslint/no-explicit-any */
import { FieldRenderProps } from 'react-final-form'

import {
  InlineRadioField,
  InlineRadioFieldClassNameProps,
} from '@cinch-labs/design-system'

export interface FindACarRadioFieldProps extends FieldRenderProps<string> {
  label?: string
  options?: Array<{ value: any; label: string; id: string }>
  onBlur?: (e: any) => void
  onFocus?: (e: any) => void
  onChange?: (e: any) => void
  helpText?: string
  classNames?: InlineRadioFieldClassNameProps
  sharedSubLabelText?: string
  sharedSubLabelClass?: string
}

const FindACarRadioField = ({
  classNames,
  input,
  label = '',
  helpText,
  options = [],
  onBlur,
  onFocus,
  onChange,
  sharedSubLabelText,
  sharedSubLabelClass,
}: FindACarRadioFieldProps) => (
  <>
    <InlineRadioField
      {...input}
      value={input.value}
      helpText={helpText}
      onBlur={(e: any) => {
        input.onBlur(e)
        if (onBlur) onBlur(e)
      }}
      onFocus={(e: any) => {
        input.onFocus(e)
        if (onFocus) onFocus(e)
      }}
      onChange={(e: any) => {
        input.onChange(e)
        if (onChange) onChange(e)
      }}
      label={label}
      options={options.map((option, index) => {
        option.id = `${input.name}-${index}`
        return option
      })}
      classNames={classNames}
    />
    {!!sharedSubLabelText && (
      <p className={sharedSubLabelClass}>{sharedSubLabelText}</p>
    )}
  </>
)

export default FindACarRadioField
